import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RecentRequisitionsComponent } from './recent-requisitions/recent-requisitions.component';
import { RequisitionCardComponentWrapper } from './recent-requisitions/requisition-card.component.wrapper';
import { RequisitionActivityComponent } from './requisition-activity/requisition-activity.component';
import { EntityActivitiesModule } from 'src/app/shared/entity-activities/entity-activities.module';

@NgModule({
  declarations: [RecentRequisitionsComponent, RequisitionCardComponentWrapper, RequisitionActivityComponent],
  imports: [
    CommonModule,
    EntityActivitiesModule
  ],
  exports: [RecentRequisitionsComponent, RequisitionCardComponentWrapper, RequisitionActivityComponent],
  entryComponents: [RequisitionActivityComponent]
})
export class RequisitionsModule { }
